const getters = {
  getNotificationWays: (state) => state.catalog.notificationWays,
  getWasStudentValidated: (state) => state.wasStudentValidated,
  getQuestionnaireList: (state) => state.questionnaire,
  getInfo: (state) => state.info,
  getConfirmationNumber: (state) => state.confirmationNumber,
  getStudentValidationMessage: (state) => state.wasStudentValidatedMessage,
};

export default getters;
